<template>
  <div class="productList">
    <div class='slider-banner'>
        <img src='https://xk.ahifeng.com/uploads/attach/2020/09/20200923/ddc39d7c25fc3771cac11de1b8551c28.jpg' />
    </div>
    <div class="nav-list clearfix">
        <router-link
        class='item'
        :class="item.id == id ? 'action' : ''"
        v-for="(item, index) in cateList"
        :key="index"
        :to="{
            path: '/citydetail/' + item.id
        }"
        >
            <div class='title'>{{item.title}}</div>
            <div class="line" v-if="(index+1)%4 !== 0"></div>
        </router-link>
    </div>
    <div class="detail_list">
        <div
        class="pic"
        v-for="(item, index) in lists"
        :key="index"
        @click="goDetail(item)"
        >
            <img :src="item.image" />
        </div>
    </div>
  </div>
</template>

<script>
import { getMultigraph,getMultigraphList } from "@api/store";

export default {
  name: "CityDetail",
  components: {
  },
  props: {},
  data: function() {
    return {
      cateList:[],
      articleInfo: {},
      id: 0,
      lists:[]
    };
  },
  watch: {
    $route(to) {
      if (to.name === "CityDetail") {
        this.id = this.$route.params.id;
        this.getDetail();
      }
    }
  },
  mounted: function() {
    this.id = this.$route.params.id;
    this.getCates();
    this.getDetail();
  },
  methods: {
    updateTitle() {
      document.title = this.articleInfo.title || this.$route.meta.title;
    },
    // 商品详情跳转
    goDetail(item) {
        console.log(item);
        if( item.good_id > 0 ){
            this.$router.push({ path: "/detail/" + item.good_id });
        }
    },
    getCates: function(){
        var that = this;
        getMultigraphList().then(res => {
            that.cateList = res.data;
        });
    },
    getDetail: function(){
        var that = this;
        getMultigraph(that.id).then(res => {
            that.articleInfo = res.data;
            that.lists = res.data.lists;
            that.updateTitle();
        });
    }
  }
};
</script>
